/** Company facts shown in the footer and contact surfaces. */
export const HQ = {
  city: 'Singapore 049422',
  /** Street address lines shown above the city. */
  lines: ['Circular Road, #02-01'],
  email: 'care@geofleet.ai',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Circular+Road+%2302-01+Singapore+049422',
};
